'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_UserDetails$package$UserFirstName$() {
  this.aG8 = null;
  this.aG9 = false;
}
export { $c_Lapp_data_UserDetails$package$UserFirstName$ as $c_Lapp_data_UserDetails$package$UserFirstName$ };
$p = $c_Lapp_data_UserDetails$package$UserFirstName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_UserDetails$package$UserFirstName$;
/** @constructor */
function $h_Lapp_data_UserDetails$package$UserFirstName$() {
}
export { $h_Lapp_data_UserDetails$package$UserFirstName$ as $h_Lapp_data_UserDetails$package$UserFirstName$ };
$h_Lapp_data_UserDetails$package$UserFirstName$.prototype = $p;
$p.aA = (function() {
  if ((!this.aG9)) {
    this.aG8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aG9 = true;
  }
  return this.aG8;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_UserDetails$package$UserFirstName$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_UserDetails$package$UserFirstName$, "app.data.UserDetails$package$UserFirstName$", ({
  Fc: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_UserDetails$package$UserFirstName$ as $d_Lapp_data_UserDetails$package$UserFirstName$ };
var $n_Lapp_data_UserDetails$package$UserFirstName$;
function $m_Lapp_data_UserDetails$package$UserFirstName$() {
  if ((!$n_Lapp_data_UserDetails$package$UserFirstName$)) {
    $n_Lapp_data_UserDetails$package$UserFirstName$ = new $c_Lapp_data_UserDetails$package$UserFirstName$();
  }
  return $n_Lapp_data_UserDetails$package$UserFirstName$;
}
export { $m_Lapp_data_UserDetails$package$UserFirstName$ as $m_Lapp_data_UserDetails$package$UserFirstName$ };
//# sourceMappingURL=app.data.-User-Details$package$-User-First-Name$.js.map
